import React from 'react';
import { TouchableOpacity, View } from 'react-native';
import { Ionicons } from '@expo/vector-icons';

import { Text } from '../../../components';
import { useThemedStyles } from '../../../hooks/useThemedStyles';
import { useTheme } from '../../../theme';
import FreshFoodLines from './FreshFoodLines';

/**
 * The day's stops that have fresh food, in run order. Tapping a stop opens its pick list when it has one.
 */
const FreshFoodList = ({ stops, onOpenStop, canOpenStop }) => {
	const styles = useThemedStyles(createStyles);
	const { theme } = useTheme();

	return (
		<View>
			{
				stops.map(stop => {
					const canOpen = Boolean(onOpenStop && canOpenStop?.(stop));

					return (
						<TouchableOpacity
							key={stop.serviceDocketId}
							style={styles.row}
							activeOpacity={0.86}
							onPress={canOpen ? () => onOpenStop(stop) : undefined}
							disabled={!canOpen}
						>
							<View style={styles.rowContent}>
								<Text style={styles.stopName}>{stop.name}</Text>
								<FreshFoodLines stop={stop} />
							</View>
							{
								canOpen && (
									<Ionicons name="chevron-forward" size={16} color={theme.text2} style={styles.chevron} />
								)
							}
						</TouchableOpacity>
					);
				})
			}
		</View>
	);
};

const createStyles = (theme) => ({
	row: {
		flexDirection: 'row',
		alignItems: 'center',
		backgroundColor: theme.mainBg3,
		borderRadius: 8,
		paddingVertical: 8,
		paddingHorizontal: 10,
		marginBottom: 6,
	},
	rowContent: {
		flex: 1,
		minWidth: 0,
		paddingRight: 8,
	},
	stopName: {
		fontSize: 13,
		fontWeight: '600',
		color: theme.text1,
	},
	chevron: {
		flexShrink: 0,
	},
});

export default FreshFoodList;
